<template>
    <div class="page-text-wrapper">
        <div v-if="pageTextDisplayHtml" class="page-text" v-html="pageTextValue"></div>
        <div v-else class="page-text">{{ pageTextValue }}</div>
    </div>
</template>

<script>
export default {
    props: {
        pageText: Object
    },

    computed: {
        /**
         * Get the page text value.
         *
         * @return {object}
         */
        pageTextValue() {
            if (!this.pageText) {
                return '';
            }

            return this.pageText.value;
        },

        /**
         * Check whether this page text contains html tags.
         *
         * @return {boolean}
         */
        pageTextDisplayHtml() {
            if (!this.pageText) {
                return false;
            }

            return this.pageText.display_html;
        }
    }
};
</script>
